export function getAppURL() {
  return process.env.REACT_APP_URL ?? "https://hub.expensehut.com";
}

export function getRecaptchaKey() {
  return process.env.REACT_APP_RECAPTCHA_KEY ?? "";
}

export const isRecaptchaEnabled =
  process.env.REACT_APP_RECAPTCHA_ENABLED === "true";

export enum ENTITLEMENT {
  // expense tracker entitlements.
  TRIAL = 0, // ALL USERS STARTS FROM HERE
  ONE_ACCOUNT = 1,
  TWO_ACCOUNT = 2,
  // Business entitlements
  DEMO = 70, // For experimental features. For now, we use no-wifi mode into this
  STARTER = 80, // POS ONLY - Fastfood, Cafes
  KIOSK = 81,
  RESTAURANT = 82, // Restaurant & retail
  DOH = 90,
  SUPPLY_CHAIN = 91,
  KIOSK_AI = 92,
  ENTERPRISE = 100, // ALL in one
}
